import './CommercialCosts.css';
import commercialBg from '../../assets/commercial_banner_bg.png';
import savesUnderline from '../../assets/figma_saves_underline.svg';

const problems = [
  {
    title: 'Rising Electricity Prices',
    desc: 'Energy costs continue to increase year after year, putting pressure on margins and budgets.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M13 2L4.09 12.11A1 1 0 0 0 5 14h6l-1 8 8.91-10.11A1 1 0 0 0 18 10h-6l1-8z" fill="#050b14" />
      </svg>
    ),
  },
  {
    title: 'Peak Demand Charges',
    desc: 'Short periods of high energy use can significantly increase electricity bills and operating costs.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" stroke="#050b14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <polyline points="16 7 22 7 22 13" stroke="#050b14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Grid Reliability Concerns',
    desc: 'Unexpected outages can disrupt operations, damage equipment and impact productivity.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 2L8 8H2l4 4-2 8 8-5 8 5-2-8 4-4h-6L12 2z" stroke="#050b14" strokeWidth="1.8" strokeLinejoin="round" fill="#050b14" />
      </svg>
    ),
  },
  {
    title: 'Limited Control Over Expenses',
    desc: 'Many businesses remain exposed to unpredictable energy pricing and market fluctuations.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <text x="12" y="17" textAnchor="middle" fontSize="18" fontWeight="700" fill="#050b14" fontFamily="Roboto,sans-serif">$</text>
      </svg>
    ),
  },
];

export default function CommercialCosts() {
  return (
    <section className="ccosts-section">
      <div className="ccosts-inner">

        {/* Heading */}
        <h2 className="ccosts-title">
          Rising Energy Costs Are Impacting{' '}
          <span className="ccosts-title-accent">
            Business Profitability
            <img src={savesUnderline} alt="" className="ccosts-accent-stroke" />
          </span>
        </h2>
        <p className="ccosts-subtitle">
          Australian businesses are under growing pressure from rising energy costs — and most have limited visibility or control over their exposure.
        </p>

        {/* 4 cards */}
        <div className="ccosts-grid">
          {problems.map((p, i) => (
            <div key={i} className="ccosts-card">
              <div className="ccosts-card-icon">{p.icon}</div>
              <h3 className="ccosts-card-title">{p.title}</h3>
              <p className="ccosts-card-desc">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA dark card */}
        <div className="ccosts-cta-wrap" style={{ backgroundImage: `url(${commercialBg})` }}>
          <div className="ccosts-cta-overlay" />
          <div className="ccosts-cta-card">
            <div className="ccosts-cta-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" stroke="#eaff50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <polyline points="16 7 22 7 22 13" stroke="#eaff50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <p className="ccosts-cta-text">
              Every dollar wasted on energy is profit lost.{' '}
              <span className="ccosts-cta-yellow">It's time to take control.</span>
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
